module.exports = __webpack_public_path__ + "first-20-uv.jpg?17510308088e0c17ecfa71730ae4e42f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-uv.jpg
// module id = 465
// module chunks = 0